import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=ce3e5c6c&scoped=true&"
import script from "./Brand.vue?vue&type=script&lang=js&"
export * from "./Brand.vue?vue&type=script&lang=js&"
import style0 from "./Brand.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Brand.vue?vue&type=style&index=1&id=ce3e5c6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3e5c6c",
  null
  
)

export default component.exports